var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "Icn/Settings");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Icn/Settings",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.0311646,18.7319354 L18.5239108,10.2393969 C20.1929262,10.6437738 22.0256031,10.1999354 23.3284569,8.89728923 C24.7665185,7.45902 25.1590569,5.37648923 24.5177031,3.58098923 L20.69118,7.40709692 L18.2304415,6.79315846 L17.6162954,4.33221231 L21.4426108,0.505896923 C19.6471108,-0.135872308 17.5643723,0.256873846 16.1265185,1.69535077 C14.8234569,2.99799692 14.3796185,4.83067385 14.7842031,6.49968923 L6.29145692,14.9924354 C4.62264923,14.5878508 2.79018,15.0312738 1.48711846,16.3343354 C0.0490569231,17.7721892 -0.343273846,19.8543046 0.29808,21.6506354 L4.12460308,17.8241123 L6.58534154,18.4380508 L7.19928,20.8989969 L3.37275692,24.7253123 C5.16867231,25.3670815 7.25120308,24.9743354 8.68926462,23.5364815 C9.99232615,22.2332123 10.4357492,20.4011585 10.0311646,18.7319354",
  id: "Fill-1",
  fill: "#617483"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0311646,18.7319354 L18.5239108,10.2393969 C20.1929262,10.6437738 22.0256031,10.1999354 23.3284569,8.89728923 C24.7665185,7.45902 25.1590569,5.37648923 24.5177031,3.58098923 L20.69118,7.40709692 L18.2304415,6.79315846 L6.58534154,18.4380508 L7.19928,20.8989969 L3.37275692,24.7253123 C5.16867231,25.3670815 7.25120308,24.9743354 8.68926462,23.5364815 C9.99232615,22.2332123 10.4357492,20.4011585 10.0311646,18.7319354",
  id: "Fill-4",
  fill: "#7E9AAE"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  fill: "#C3C8CE",
  points: "5.03890615 3.87545538 3.66792923 5.24664 12.6470908 14.2258015 14.0182754 12.85524"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#DFE2E5",
  points: "2.60288308 1.27575 1.83546 2.04317308 1.06803692 2.81059615 2.98254462 5.93179615 5.72429077 3.19025769"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9789077,19.7998062 L18.1915615,14.0122523 C18.0474231,13.8685292 17.8783615,13.7518062 17.6928923,13.6674831 L14.6032615,12.2705446 L13.3328077,13.5403754 L12.0623538,14.8106215 L13.4597077,17.90046 C13.5436154,18.0863446 13.6605462,18.2547831 13.8046846,18.3991292 L19.5922385,24.1866831 C20.2518692,24.8465215 21.3214846,24.8465215 21.9813231,24.1866831 L23.9789077,22.1888908 C24.6387462,21.5294677 24.6387462,20.4596446 23.9789077,19.7998062",
  id: "Fill-11",
  fill: "#D30028"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#D67561",
  points: "21.3982269 22.2621023 14.2585962 15.1226792 15.08085 14.3002177 22.2206885 21.4396408"
})));

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "26px",
    viewBox: "0 0 25 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Settings.a9ccc584.svg";
export { ForwardRef as ReactComponent };